<template>
  <div>
    <el-row>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">基础数据综合应用</el-breadcrumb-item>
      <el-breadcrumb-item>静态数据</el-breadcrumb-item>
      <el-breadcrumb-item>单井基础信息</el-breadcrumb-item>
    </el-breadcrumb>
  </el-row>
    <el-row type="flex" justify="end">
    <el-button type="primary">设置</el-button>
    <el-button type="primary">筛选</el-button>
    <el-button type="primary">查询</el-button>
    <el-button type="primary">导出</el-button>
  </el-row>
    <el-row>
    <div>
    <el-table
        :data="tableData"
        @row-contextmenu="rowContextmenu"
        border
        style="width: 100%"
        height="700px">
      <el-table-column
          fixed
          prop="jh"
          label="井号"
          width="100">
      </el-table-column>
      <el-table-column
          prop="kfb"
          label="开发部"
          width="120">
      </el-table-column>
      <el-table-column
          prop="yt"
          label="油田"
          width="120">
      </el-table-column>
      <el-table-column
          prop="jq"
          label="井区"
          width="80">
      </el-table-column>
      <el-table-column
          prop="cw"
          label="层位"
          width="80">
      </el-table-column>
      <el-table-column
          prop="yqczs"
          label="目的油气藏中深(m)"
          width="150">
      </el-table-column>
      <el-table-column
          prop="yqclx"
          label="主要目的层油气藏类型"
          width="160"/>
      <!--      <template #default="scope">-->
      <!--        <el-button-->
      <!--            @click.prevent="deleteRow(scope.$index, tableData)"-->
      <!--            type="text"-->
      <!--            size="small">-->
      <!--          移除-->
      <!--        </el-button>-->
      <!--      </template>-->
      <el-table-column
          prop="zyyqcsd"
          label="钻遇油气层深度(m)"
          width="150">
      </el-table-column>
      <el-table-column
          prop="zyzbx"
          label="钻遇油气层层面坐标X(m)"
          width="190">
      </el-table-column>
      <el-table-column
          prop="zyzby"
          label="钻遇油气层层面坐标Y(m)"
          width="190">
      </el-table-column>
      <el-table-column
          prop="mqsccw"
          label="目产生产层位"
          width="120">
      </el-table-column>
      <el-table-column
          prop="ysdcyl"
          label="原始地层压力(Mpa)"
          width="150">
      </el-table-column>
      <el-table-column
          prop="yymd"
          label="原油密度(t/m3)"
          width="130">
      </el-table-column>
      <el-table-column
          prop="qxdmd"
          label="气相对密度"
          width="120">
      </el-table-column>
      <el-table-column
          prop="ysdcslg"
          label="原始地层水氯根(mg/L)"
          width="180">
      </el-table-column>
      <el-table-column
          prop="remark"
          label="备注"
          width="120">
      </el-table-column>
      <context-button v-if="menuVisible" @foo="foo" ref="contextButton" @handleOne="handleOne" @handleTwo="handleTwo" @handleThree="handleThree"></context-button>
    </el-table>
    </div>
  </el-row>
  </div>
</template>

<script>
import contextButton from "@/components/contextButton";
export default {
  methods: {
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    rowContextmenu(row, column, event) {
      this.menuVisible = false
      this.menuVisible = true
      // 阻止右键默认行为
      event.preventDefault()
      this.$nextTick(() => {
        this.$refs.contextButton.init(row, column, event)
      })
    },
    foo() { // 取消鼠标监听事件 菜单栏
      this.menuVisible = false
      document.removeEventListener('click', this.foo)
    },
    handleOne() {
      console.log('点击菜单一')
    },

    handleTwo() {
      console.log('点击菜单二')
    },
    handleThree() {
      console.log('点击菜单三')
    }
  },
  data() {
    return {
      tableData: [{
        jh: 'DN211W',
        kfb: '迪那油气开发部',
        yt: '迪那2气田',
        jq: '迪那2',
        cw: 'N1-2k',
        yqczs: 2679.25,
        mqsccw: 'N1-2k'
      }, {
        jh: 'DH1-H2',
        kfb: '东河油气开发部',
        yt: '东河塘油田',
        jq: '东河1',
        cw: 'JIV',
        yqczs: 5480,
        yqclx: '层状边水凝析气藏',
        zyyqcsd: 5484.23,
        zyzbx: 4594018.94,
        zyzby: 14678226.16,
        mqsccw: 'CⅢ',
        ysdcyl: 60.94,
        yymd: 0.8172,
        qxdmd: 0.6454,
        ysdcslg: 10.65
      }, {
        jh: 'DH1-H2',
        kfb: '东河油气开发部',
        yt: '东河塘油田',
        jq: '东河1',
        cw: 'JⅢ',
        yqczs: 5480,
        yqclx: '层状边水凝析气藏',
        zyyqcsd: 5484.23,
        zyzbx: 4594018.94,
        zyzby: 14678226.16,
        mqsccw: 'CⅢ',
        ysdcyl: 60.94,
        yymd: 0.8172,
        qxdmd: 0.6454,
        ysdcslg: 10.65
      }, {
        jh: 'DH1-6-9',
        kfb: '东河油气开发部',
        yt: '东河塘油田',
        jq: '东河1',
        cw: 'JIV',
        yqczs: 5480,
        yqclx: '层状边水凝析气藏',
        zyyqcsd: 5484.23,
        zyzbx: 4594018.94,
        zyzby: 14678226.16,
        mqsccw: 'CⅢ',
        ysdcyl: 60.94,
        yymd: 0.8172,
        qxdmd: 0.6454,
        ysdcslg: 10.65
      }, {
        jh: 'DH1-6-9',
        kfb: '东河油气开发部',
        yt: '东河塘油田',
        jq: '东河1',
        cw: 'CⅢ',
        yqczs: 5480,
        yqclx: '层状边水凝析气藏',
        zyyqcsd: 5484.23,
        zyzbx: 4594018.94,
        zyzby: 14678226.16,
        mqsccw: 'CⅢ',
        ysdcyl: 60.94,
        yymd: 0.8172,
        qxdmd: 0.6454,
        ysdcslg: 10.65
      }, {
        jh: 'DH1-6-9',
        kfb: '东河油气开发部',
        yt: '东河塘油田',
        jq: '东河1',
        cw: 'JⅢ',
        yqczs: 5480,
        yqclx: '层状边水凝析气藏',
        zyyqcsd: 5484.23,
        zyzbx: 4594018.94,
        zyzby: 14678226.16,
        mqsccw: 'CⅢ',
        ysdcyl: 60.94,
        yymd: 0.8172,
        qxdmd: 0.6454,
        ysdcslg: 10.65
      }, {
        jh: 'DH1-4-7',
        kfb: '东河油气开发部',
        yt: '东河塘油田',
        jq: '东河1',
        cw: 'JIV',
        yqczs: 5480,
        yqclx: '层状边水凝析气藏',
        zyyqcsd: 5484.23,
        zyzbx: 4594018.94,
        zyzby: 14678226.16,
        mqsccw: 'CⅢ',
        ysdcyl: 60.94,
        yymd: 0.8172,
        qxdmd: 0.6454,
        ysdcslg: 10.65
      }, {
        jh: 'DH1-4-7',
        kfb: '东河油气开发部',
        yt: '东河塘油田',
        jq: '东河1',
        cw: 'JⅢ',
        yqczs: 5480,
        yqclx: '层状边水凝析气藏',
        zyyqcsd: 5484.23,
        zyzbx: 4594018.94,
        zyzby: 14678226.16,
        mqsccw: 'CⅢ',
        ysdcyl: 60.94,
        yymd: 0.8172,
        qxdmd: 0.6454,
        ysdcslg: 10.65
      }],
      menuVisible: false
    }
  },
  components: {
    contextButton
  }
}
</script>